import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import {
  makeStyles,
  CircularProgress,
  Typography
} from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
  loading: {
    padding: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  spinner: {
    marginRight: theme.spacing(3)
  }
}));

const Loading = props => {
  const classes = useStyles();
  const { t } = useTranslation();

  return <div className={classes.loading}>
    <CircularProgress className={classes.spinner} />
    <Typography variant="subtitle1" component="span" className={classes.message}>{props.message || `${t('common:loading')}...`}</Typography>
  </div>
};

Loading.propTypes = {
  message: PropTypes.string
}

export default Loading;
